import React from 'react';
import { Search, ShieldCheck, BarChart3, Database } from 'lucide-react';
import { ParallaxSection } from './ParallaxSection';
const features = [{
  icon: Search,
  title: 'Search',
  description: 'Find exact biospecimens across diverse populations instantly.'
}, {
  icon: ShieldCheck,
  title: 'Match',
  description: 'AI matching ensures 100% compliance and protocol adherence.'
}, {
  icon: BarChart3,
  title: 'Analyze',
  description: 'Deep data insights across longitudinal patient records.'
}, {
  icon: Database,
  title: 'Access',
  description: 'Streamlined procurement and delivery logistics.'
}];
export function FeaturesSection() {
  return <section id="features" className="h-[1024px] px-4 bg-gradient-to-b from-[#042854] to-[#031d3d] flex items-center justify-center overflow-hidden" data-id="element-37">
      <div className="max-w-7xl mx-auto w-full" data-id="element-38">
        <ParallaxSection speed={0.2} data-id="element-39">
          <div className="mb-16 max-w-4xl mx-auto text-center" data-id="element-40">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#a1da52]" data-id="element-41">
              Unum
            </h2>
            <p className="text-lg text-white/80" data-id="element-42">
              Unum is transforming siloed biobanks into a federated network that
              keeps PHI data local and secure while enabling global discovery.
            </p>
          </div>
        </ParallaxSection>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-43">
          {features.map((feature, index) => <ParallaxSection key={feature.title} speed={0.1 * (index + 1)} data-id="element-44">
              <div className="group p-6 rounded-xl bg-white/5 border border-white/10 hover:bg-white/10 transition-all duration-300 hover:-translate-y-1" data-id="element-45">
                <div className="mb-4 inline-flex p-3 rounded-lg bg-[#a1da52]/10 text-[#a1da52] group-hover:bg-[#a1da52] group-hover:text-[#042854] transition-colors" data-id="element-46">
                  <feature.icon className="w-8 h-8" data-id="element-47" />
                </div>
                <h3 className="text-xl font-bold mb-2" data-id="element-48">{feature.title}</h3>
                <p className="text-white/60 text-sm leading-relaxed" data-id="element-49">
                  {feature.description}
                </p>
              </div>
            </ParallaxSection>)}
        </div>
      </div>
    </section>;
}